import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_sales_tracking_report_RowClass } from '../../../dbschema';

export class DgMktSalesTrackingReportContainerModel extends BaseContainerModel {
  bl_dgmkt_sales_tracking_report: bl_dgmkt_sales_tracking_report_RowClass =
    new bl_dgmkt_sales_tracking_report_RowClass();
}

